export enum NotificationsEnum {
	chatMessage = 0,
	chatAttachment = 1,
	appointmentDatetimeChanged = 2,
	appointmentStatusChanged = 3,
	invitationFinished = 4,
	newPrescriptionUploaded = 7,
	email = 8,
}
